module.exports = __webpack_public_path__ + "img/avatar-14.9a46d51f.jpg";